export enum CtaTexts {
  GET_STARTED = 'Get started',
  GET_STARTED_WITH_DISCOUNT = 'Get started with 50% off',
  SEE_MENU = 'See Menu',
}
